export const VALIDATION_CHANGED     = 'changed'
export const VALIDATION_NOT_EMPTY   = 'not-empty'
export const VALIDATION_EMPTY       = 'empty'
export const VALIDATION_CONTAINS    = 'contains'
export const VALIDATION_MATCHES     = 'matches'

export const VALIDATION_EQUALS      = 'equals'
export const VALIDATION_GREATER     = 'greater'
export const VALIDATION_LESS        = 'less'
export const VALIDATION_BETWEEN     = 'between'

export const VALIDATION_BEFORE_DAY_DELTA      = 'before-day-delta'  // this is for delta from trigger date
export const VALIDATION_AFTER_DAY_DELTA       = 'after-day-delta'   // this is for delta from trigger date

export const VALIDATION_BEFORE_DATE = 'before-date'     // this is for specified YYYY-MM-DD date
export const VALIDATION_AFTER_DATE  = 'after-date'      // this is for specified YYYY-MM-DD date

export const VALIDATION_INCLUDES    = 'includes'
export const VALIDATION_EXCLUDES    = 'excludes'

// for checkbox
export const VALIDATION_CHECKED     = 'checked'
export const VALIDATION_UNCHECKED   = 'unchecked'

// special (not for validation selector) for dropdown like fields automations
export const VALIDATION_FROM_TO     = 'from-to'

export const VALIDATION_LABELS = {
    [VALIDATION_CHANGED]    : 'Changed',
    [VALIDATION_NOT_EMPTY]  : 'Not empty',
    [VALIDATION_EMPTY]      : 'Empty',
    [VALIDATION_CONTAINS]   : 'Contains',
    [VALIDATION_MATCHES]    : 'Matches',

    [VALIDATION_EQUALS]     : 'Equals',
    [VALIDATION_GREATER]    : 'Greater',
    [VALIDATION_LESS]       : 'Less',
    [VALIDATION_BETWEEN]    : 'Between',

    [VALIDATION_BEFORE_DAY_DELTA]     : 'Is before',
    [VALIDATION_AFTER_DAY_DELTA]      : 'Is after',

    [VALIDATION_INCLUDES]   : 'Includes',
    [VALIDATION_EXCLUDES]   : 'Excludes',

    [VALIDATION_CHECKED]    : 'Checked',
    [VALIDATION_UNCHECKED]  : 'Unchecked',

    [VALIDATION_FROM_TO]    : 'From to', // should not be used actually

    
    
}